/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-props-no-spreading */
import { useTranslate } from 'hooks/useTranslate';

import Page from 'modules/_shared/components/Pages/Page';
import CardKPI from 'modules/_shared/components/Cards/CardKPI';
import CustomLoading from 'modules/_shared/components/CustomLoading';
import PageListHeader from 'modules/_shared/components/Headers/PageListHeader';
import CustomDataTable from 'modules/_shared/components/Tables/CustomDataTable';
import Button, { ButtonVariants } from 'modules/_shared/components/Buttons';

import { useEmployeeList } from './hooks/useEmployeeList';

function EmployeeList() {
  const { t } = useTranslate();

  const {
    data: {
      actualSociety,
      tableData,
      currentTableColumns,
      activeEmployees,
      employees,
      isAdmin,
      isReadOnly,
      pageDescription,
      activeEmployeesWithIncentive,
      inactiveEmployeesWithIncentive,
      showInactives,
      kpiFilter,
    },
    actions: {
      handleLoadEmployees,
      handleFilterEmployees,
      handleToggleShowInactives,
      handleKpiFilterClick,
    },
    isLoading,
  } = useEmployeeList();

  return (
    <Page id="employees-list-page">
      <PageListHeader
        subTitle={t('Employees')}
        description={pageDescription}
        actions={
          isAdmin
            ? [
                <Button
                  key="toggle-inactives"
                  onClick={handleToggleShowInactives}
                  variant={ButtonVariants.LIGHT}
                  outlineStyle
                >
                  <em
                    className={`icon ni ni-${
                      showInactives ? 'eye-off' : 'eye'
                    }`}
                  />
                  <span>
                    {showInactives ? t('HideInactives') : t('SeeInactives')}
                  </span>
                </Button>,
                <Button
                  key="filter-employees"
                  disabled={isReadOnly}
                  variant={ButtonVariants.LIGHT}
                  onClick={handleFilterEmployees}
                  outlineStyle
                >
                  <em className="icon ni ni-filter" />
                  <span>{t('FilterEmployees')}</span>
                </Button>,
                <Button
                  key="update-employees"
                  disabled={isReadOnly}
                  onClick={handleLoadEmployees}
                >
                  <em className="icon ni ni-download-cloud" />
                  <span>{t('UpdateEmployees')}</span>
                </Button>,
              ]
            : []
        }
      />

      <div className="nk-block row mb-5">
        <div className="col-4">
          <CardKPI
            title={t('ActiveEmployees')}
            value={activeEmployees?.length || 0}
            valueExtra={`${t('of')} ${employees.length}`}
            onClick={() => handleKpiFilterClick('active')}
            isActive={kpiFilter === 'active'}
          />
        </div>
        <div className="col-4">
          <CardKPI
            title={t('ActiveEmployeesWithIncentives')}
            value={activeEmployeesWithIncentive}
            valueExtra={`${t('of')} ${activeEmployees?.length || 0}`}
            onClick={() => handleKpiFilterClick('activeWithIncentives')}
            isActive={kpiFilter === 'activeWithIncentives'}
          />
        </div>
        <div className="col-4">
          <CardKPI
            title={t('InactiveEmployeesWithIncentives')}
            value={inactiveEmployeesWithIncentive}
            valueExtra={`${t('of')} ${
              employees.length - (activeEmployees?.length || 0)
            }`}
            onClick={() => handleKpiFilterClick('inactiveWithIncentives')}
            isActive={kpiFilter === 'inactiveWithIncentives'}
          />
        </div>
      </div>

      <CustomDataTable
        data={tableData}
        columns={currentTableColumns}
        searchBy={['externalIdSearch', t('Name'), t('Email'), t('TaxId')]}
        searchByPlaceholder={[t('id'), t('name'), t('email'), t('cif')].join()}
        pagination
        className="nk-tb-list"
        actions
        showDense
        fileName={`${t('EmployeesList')} ${actualSociety?.name}`}
      />

      {(isLoading || !actualSociety) && <CustomLoading />}
    </Page>
  );
}

export default EmployeeList;
